<template>
  <div style="cursor: help; height: 100%;">
    <apexchart
      height="100%"
      type="bar"
      :options="options"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { movimentacoesCategorias } from "@/api/compras/MateriaPrima.js";
import { opcoes } from "./Opcoes";
import {logout} from "@/helpers";

const SERIE_PADRAO = [0,0,0,0,0,0,0,0,0,0,0,0,0];

export default {
  data: () => ({
    options: opcoes,
    series: [],
    maxValor: 0,
  }),
  computed: {
    ...mapGetters({
      grupoCompra: "usuario/getGrupoCompras",
    }),
    maxEscala() {
      return this.maxValor + this.maxValor / 4;
    },
    yaxis: function () {
      return {
        title: {
          text: "Análise Compra vs Venda",
          style: {
            color: "#000",
            fontSize: "12px",
            fontWeight: 600,
            cssClass: "apexcharts-yaxis-title",
          },
        },
        labels: {
          minWidth: 50,
          maxWidth: 50,
          formatter: (n) => {
            return this.formatter(n) || "";
          },
          style: {
            color: "#000",
            cssClass: "apexcharts-yaxis-title",
          },
        },
        forceNiceScale: true,
        max: this.maxEscala > 0 ? this.maxEscala : 1,
        min: 0
      };
    },
  },
  watch: {
    grupoCompra () {
      this.limparGrafico();
      this.buscarDadosGrafico();
    },
  },
  created() {
    this.limparGrafico();
    this.buscarDadosGrafico();
  },
  methods: {
    limparGrafico() {
      const compras = {
        name: "Compras",
        color: "rgba(4, 53, 84, 1)",
        data: SERIE_PADRAO
      };

      const vendas = {
        name: "Vendas",
        color: "rgba(214, 14, 43,1)",
        data: SERIE_PADRAO
      };

      this.series = [compras, vendas];
    },
    buscarDadosGrafico () {
      const params = {
        grupo: this.grupoCompra,
      };

      this.$store.dispatch('loading/addRequisicao',
        movimentacoesCategorias(params)
        .then((data) => {
          const { compras: serie_compras, saidas: serie_saidas, ref } = data.movimentacoes;

          this.maxValor = 0;

          serie_compras.concat(serie_saidas).forEach((item) => {
            if (parseInt(item) > this.maxValor) {
              this.maxValor = parseInt(item);
            }
          });

          this.options = {
            yaxis: this.yaxis,
            labels: ref,
          };

          const compras = {
              name: "Compras",
              color: "rgba(4, 53, 84, 1)",
              data: serie_compras,
            };

          const vendas = {
            name: "Vendas",
            color: "rgba(214, 14, 43,1)",
            data: serie_saidas,
          };

          this.series = [compras, vendas];
        })
        .catch(logout)
      );
    },

    formatter: function (n) {
      var ranges = [
        { divider: 1e15, suffix: "P" },
        { divider: 1e12, suffix: "T" },
        { divider: 1e9, suffix: "G" },
        { divider: 1e6, suffix: "M" },
        { divider: 1e3, suffix: "k" },
      ];

      for (var i = 0; i < ranges.length; i++) {
        if (n >= ranges[i].divider) {
          return (
            (Math.round(n) / ranges[i].divider).toFixed(0).toString() +
            ranges[i].suffix
          );
        }
      }

      return n;
    },
  },
};
</script>
